import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Icons from "../myIcon/Icons";
import EnquiryPopup from "./EnquiryPopup";
import { BaseUrl } from "../helper/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
 
export default function Footer({footerHide}) {
    const [modalShow, setModalShow] = useState(false);
    const navigate = useNavigate();
    const [ip, setIp] = useState("");
    const [loading, setLoading] = useState(false);

    const [postData, setPostData] = useState({ email: "", source_url: sessionStorage.getItem("first_landing_url"), ip_address: ip, });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPostData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    useEffect(() => {
        // Get IP address on component load
        const fetchIp = async () => {
            const res = await fetch("https://api.ipify.org?format=json");
            const data = await res.json();
            setIp(data.ip);
        };
        fetchIp();
    }, []);

    // Submit handler
    const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
        if (
        key !== "source_url" &&
        key !== "ip_address" &&
        (value === "" || value === null)
        ) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
        }
    }

    const payload = {
        ...postData,
        ip_address: ip,
        source_url: sessionStorage.getItem("first_landing_url"),
    };

    setLoading(true);

    try {
        await axios.post(`${BaseUrl}/api/newslatter-saves`, payload);
        navigate("/thankyou");
        setPostData({ email: "", source_url: sessionStorage.getItem("first_landing_url"), ip_address: ip, });
    } catch (error) {
        console.error("Error submitting newsletter:", error);
        toast.error("Something went wrong. Please try again.");
    } finally {
        setLoading(false);
    }
    };

  return (
    <>
      <footer className={`footer ${footerHide || ""}`}>
        <div className="container">
          <div className="row">

            <div className="col-lg-4 col-12 col-sm-5 col-md-5">
              <div className="footer-about">
                <p>Luxury interiors for iconic living</p>
                <Link to={"contact"} className="default-btn">Get in Touch <Icons name="Longarrow_right"/></Link>
                <br/>
                <Link to={""} className="default-btn colored-btn">Download Brochure <Icons name="Longarrow_right"/></Link>
              </div>
            </div>

            <div className="col-lg-2 col-4 col-sm-2 col-md-2">
              <ul className="footer-links">
                <li><Link to={"/blog"}>Blogs <Icons name="Longarrow_right"/></Link></li>
                <li><Link to={"/about"}>About <Icons name="Longarrow_right"/></Link></li>
                <li><Link to={"/services"}>Services <Icons name="Longarrow_right"/></Link></li>
                <li><Link to={"/project"}>Projects <Icons name="Longarrow_right"/></Link></li>
              </ul>
            </div>

            <div className="col-lg-3 col-8 col-sm-5 col-md-5">  
                <ul className="footer-address">
                  <li><Link to="mailto:info@saysha.in">info@saysha.in</Link></li>
                  <li><Link to="tel:+91-8397000603">+91-8397000603</Link> | <Link to="tel:+91-9810568659">+91-9810568659</Link></li>
                  <li>D-43, 1st Floor, Sushant Lok III Extension, Sector-57, Gurgaon, Haryana - 122001</li>
                </ul>
            </div>

            <div className="col-lg-3 col-9 col-sm-6 col-md-5">  
                <div className='subscribe-form'>
                  <p>Sign Up For Newsletter</p>
                  <form onSubmit={handleSubmit}>
                      <input value={postData.email} onChange={handleChange} type="email" name="email" placeholder="Enter Email" className="form-control"/>
                      <button type="submit">
                        {loading ? <Icons name="spinner" /> : <Icons name="Longarrow_right" />}
                      </button>  
                  </form>
                </div>

                <ul className="footer-social">
                  <li><Link to={"https://www.facebook.com/SayshaInterior"} target="_blank" aria-label="Facebook"><Icons name="facebook"/></Link></li>

                  <li><Link to={"https://www.linkedin.com/company/saysha-interiors-pvt-ltd"} target="_blank" aria-label="linkedin"><Icons name="linkedin"/></Link></li>

                  <li><Link to={"https://in.pinterest.com/sayshainterior"} target="_blank" aria-label="pinterest"><Icons name="pinterest"/></Link></li>

                  <li><Link to={"https://twitter.com/sayshainteriors"} target="_blank" aria-label="twitter"><Icons name="twitter" /></Link></li>

                  <li><Link to={"https://youtube.com/@sayshainteriors?si=IwVIclXE3UWuoXJj"} target="_blank" aria-label="youtube"><Icons name="youtube"/></Link></li>

                  <li><Link to={"https://www.instagram.com/sayshainteriors?igsh=MXNqcXoxejJlaXF6Mg=="} target="_blank" aria-label="instagram"><Icons name="instagram" /></Link></li>
                </ul>
            </div>

            {/* <div className="col-lg-12">
              <div className="footer-cname">
                <h4 className="wow animate__animated animate__slideInUp" data-wow-duration="1s" data-wow-delay="0.2s" style={{ visibility: 'hidden' }}>Saysha</h4>
              </div>
            </div> */}

            <div className="col-lg-12">
              <div className="footer-copyright">
                <ul>
                  <li><Link to="/terms-and-condition">Terms & Conditions <Icons name="Longarrow_right"/></Link></li>
                  <li><Link to="/privacy-policy">Privacy Policy <Icons name="Longarrow_right"/></Link></li>
                </ul>
                <p>© 2025 Saysha. All rights reserved.</p>
              </div>
            </div>

          </div>
        </div>
      </footer>

      <Link className="enquire-button" onClick={() => setModalShow(true)}>Enquire Now</Link>
    
      <EnquiryPopup show={modalShow} onHide={() => setModalShow(false)}/>
    </>
  )
}
